export const iconFontAwesomeCampingMapLocation = (
	<i className="fa-solid fa-map-location"></i>
);
